
<template>   
    <router-view></router-view>  
</template>
 
<script lang="ts">
	 
    import { Options, Vue  } from "vue-class-component";  
     
    @Options({
        name: "AlunoIndex",
        components: {    },  
    }) 
    export default class AlunoIndex extends Vue {
         
    }
  
</script>
  